window.okeReviewsWidgetOnInit = function () {
    setupAggregateSection();

    const warButton = document.querySelector(".okeReviews-reviewsWidget-header .js-okeReviews-writeReview");
    const controlsSelect = document.querySelector(".okeReviews-reviews .okeReviews-reviews-controls-sort");
    if (warButton && controlsSelect) {
        controlsSelect.insertAdjacentElement("afterend", warButton);
    }
};

function setupAggregateSection() {
    // Move aggregate section into header
    const destination = document.querySelector(".okeReviews-customAggregateHolder");
    const aggregateSection = document.querySelector(".okeReviews-reviewsWidget-reviewsAggregate.js-okeReviews-reviewsAggregateContainer");
    if (destination && aggregateSection) {
        destination.insertAdjacentElement('afterbegin', aggregateSection);
    }

    const aggregatePrimary = document.querySelector(".okeReviews-reviewsAggregate-primary");
    const ratingDistribution = document.querySelector(".okeReviews-reviewsAggregate-ratingDistribution.js-or-rtgDis");
    // Move rating distribution to aggragate primary
    if (aggregatePrimary && ratingDistribution) {
        aggregatePrimary.insertAdjacentElement('afterbegin', ratingDistribution);
    }

    // Make sure that aggregate is setup before showing
    const reviewHolder = document.querySelector(".okeReviews-widget-holder");
    if (reviewHolder) {
        reviewHolder.style.visibility = "visible";
    }
}